<template>
  <v-card :value="value" v-bind="$attrs" self-align="center" :style="'border: 1px solid ' + Colors.MenuTextColor">
    <v-card-actions v-if="!isOnMobile" class="ma-0 pa-0" align="center" justify="center">
      <v-card-text class="subtitle-1 ma-0 pa-1">
        {{ title }}
      </v-card-text>
    </v-card-actions>
    <t-divider></t-divider>
    <!-- <v-card-actions class="ma-0 pa-0">
      <v-col class="ma-0 pa-0">
        <v-row justify="space-around" class="ma-0 pa-0">
          <t-button @click="showClock = false" style="width: 50%"><v-icon>mdi-calendar</v-icon></t-button>
          <t-button @click="showClock = true" style="width: 50%"><v-icon>mdi-clock</v-icon></t-button>
        </v-row>
      </v-col>
    </v-card-actions> -->
    <v-card-actions :style="'background: ' + Colors.MenuColor + '; color: ' + Colors.MenuTextColor" class="ma-0 pa-1" align="center" justify="center">
      <v-card-text class="subtitle-1 ma-0 pa-0">
        {{ datesText }}
      </v-card-text>
    </v-card-actions>
    <t-divider></t-divider>
    <v-card-actions class="ma-0 pa-0">
      <v-time-picker v-if="showClock1" class="ma-0 pa-0" v-model="time1" :min="getMinTime1()" :scrollable="true" format="24hr">
        <v-col class="ma-0 pa-0">
          <t-divider></t-divider>
          <v-row :class="isOnMobile ? 'ma-0 pa-0' : 'ma-1 pa-0'">
            <v-spacer></v-spacer>
            <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="showClock1 = false">{{ buttonOKText }}</v-btn>
          </v-row>
        </v-col>
      </v-time-picker>
      <v-time-picker v-else-if="showClock0" class="ma-0 pa-0" format="24hr" :scrollable="true" v-model="time0">
        <v-col class="ma-0 pa-0">
          <t-divider></t-divider>
          <v-row :class="isOnMobile ? 'ma-0 pa-0' : 'ma-1 pa-0'">
            <v-spacer></v-spacer>
            <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="showClock0 = false">{{ buttonOKText }}</v-btn>
          </v-row>
        </v-col>
      </v-time-picker>
      <v-date-picker v-else class="ma-0 pa-0" firstDayOfWeek="1" :picker-date="dateDisplayed" :selected-items-text="datesText" no-title :locale="s_Locale" mode="range" range v-model="datesString" :min="min.toStringWithFormat('yyyy-MM-dd')" :max="max.toStringWithFormat('yyyy-MM-dd')" show-current>
        <v-col class="ma-0 pa-0">
          <t-divider></t-divider>
          <v-row class="ma-0 pa-1" justify="center">
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded outlined small color="primary" @click.native="setDates(0)">{{ s_Today }}</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded outlined small color="primary" @click.native="setDates(1)">{{ s_Yesterday }}</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded outlined small color="primary" @click.native="setDates(2)">{{ s_TheWeek }}</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded outlined small color="primary" @click.native="setDates(3)">{{ s_ThisMonth }}</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded outlined small color="primary" @click.native="setDates(4)">{{ s_PreviousMonth }}</v-btn>
          </v-row>
          <t-divider></t-divider>
          <v-row :class="isOnMobile ? 'ma-0 pa-0' : 'ma-1 pa-0'">
            <v-spacer></v-spacer>
            <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="cancelInput()">{{ buttonCancelText }}</v-btn>
            <v-btn class="ma-1 pa-0" text outlined :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="handleInput()">{{ buttonOKText }}</v-btn>
          </v-row>
        </v-col>
      </v-date-picker>
    </v-card-actions>
  </v-card>
</template>

<script>
import { TR } from "../../main";
export default {
  props: {
    value: {
      type: Array,
      default: () => [null, null],
    },
    label: {
      type: String,
      default: () => TR.TDatePicker_FromDateToDate,
    },
    min: {
      type: Date,
      default: () => new Date().addMonths(-36),
    },
    max: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      s_Locale: TR.Locale,
      showClock0: false,
      showClock1: false,
      title: TR.TDatePicker_ChooseRange,
      datesString: [null, null], //new Date().toStringWithFormat("yyyy-MM-dd"), new Date().toStringWithFormat("yyyy-MM-dd")],
      dates: [this.value[0], this.value[1]],
      time0: "00:00",
      time1: "23:59",
      datesLast: [this.value[0], this.value[1]],
      datesText: TR.TDatePicker_PleaseChooseRange,
      dateDisplayed: undefined,
      s_Today: TR.Today,
      s_Yesterday: TR.Yesterday,
      s_TheWeek: TR.TheWeek,
      s_ThisMonth: TR.ThisMonth,
      s_PreviousMonth: TR.PreviousMonth,
      buttonOKText: TR.OK,
      buttonCancelText: TR.Cancel,
    };
  },
  computed: {},
  methods: {
    click() {},
    getMinTime1() {
      return this.datesString[0] && this.datesString[1] && this.datesString[0] == this.datesString[1] ? this.time0 : undefined;
    },
    setDates(type) {
      var date = new Date();
      this.datesString = [null, null];
      //this.$forceUpdate();
      switch (type) {
        case 0:
          this.datesString[0] = date.toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = date.toStringWithFormat("yyyy-MM-dd");
          break;

        case 1:
          this.datesString[0] = date.addDays(-1).toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = date.addDays(-1).toStringWithFormat("yyyy-MM-dd");
          break;

        case 2:
          this.datesString[0] = date.getMonday().toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = date.toStringWithFormat("yyyy-MM-dd");
          break;

        case 3:
          this.datesString[0] = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 1).toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = new Date().toStringWithFormat("yyyy-MM-dd"); // new Date(date.getFullYear(), date.getMonth(), 1).addDays(-1).toStringWithFormat("yyyy-MM-dd");
          break;

        case 4:
          this.datesString[0] = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 1).addMonths(-1).toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = new Date(date.getFullYear(), date.getMonth(), 1).addDays(-1).toStringWithFormat("yyyy-MM-dd");
          break;
      }
      this.$forceUpdate();
      this.$nextTick(() => {
        this.showClock0 = false;
        this.showClock1 = false;
      });
    },
    clearDates() {
      this.dates[0] = null;
      this.dates[1] = null;
      this.datesString[0] = null;
      this.datesString[1] = null;
      this.handleInput();
    },
    cancelInput() {
      if (this.datesLast[0]) {
        this.datesString[0] = this.datesLast[0].toStringWithFormat("yyyy-MM-dd");
      } else {
        this.datesString[0] = null;
      }
      if (this.datesLast[1]) {
        this.datesString[1] = this.datesLast[1].toStringWithFormat("yyyy-MM-dd");
      } else {
        this.datesString[1] = null;
      }
      this.dialog.result = null;
      this.dialog.close();
    },
    handleInput() {
      if ((this.datesString[0] && !this.datesString[1]) || (!this.datesString[0] && this.datesString[1])) {
        this.dialogLoader.showError(TR.TDatePicker_PleaseChooseEndDate);
        return;
      }
      if (!this.datesString[0] && !this.datesString[1]) {
        this.dialogLoader.showError(TR.TDatePicker_RangeNotSet);
        return;
      }
      this.datesLast = this.dates.slice();
      this.dialog.result = this.dates;
      this.dialog.close();
    },
    refreshValues() {
      if (this.datesString[0]) {
        this.dates[0] = (this.datesString[0] + " " + this.time0 + ":00").parseDateWithFormat("yyyy-MM-dd HH:mm:ss");
      } else {
        this.dates[0] = null;
      }
      if (this.datesString[1]) {
        this.dates[1] = (this.datesString[1] + " " + this.time1 + ":00").parseDateWithFormat("yyyy-MM-dd HH:mm:ss");
      } else {
        this.dates[1] = null;
      }
      if (this.datesString[0] && this.datesString[1]) {
        this.dates[1] = (this.datesString[1] + " " + this.time1 + ":00").parseDateWithFormat("yyyy-MM-dd HH:mm:ss");
        if (this.dates[0].getTime() > this.dates[1].getTime()) {
          this.datesString.reverse();
          this.dates.reverse();
          this.dates[0].setSeconds(0);
          this.dates[1].setSeconds(59);
        }
        // this.dates[0] = this.dates[0].getDateWithoutTime();
        // this.dates[1] = this.dates[1].getDateWithoutTime().addDays(1).addMilliseconds(-1);

        this.datesText = this.dates[0].toStringWithFormat("dd.MM.yyyy HH:mm") + " - " + this.dates[1].toStringWithFormat("dd.MM.yyyy HH:mm");
      } else {
        this.datesText = (this.dates[0] ?? this.dates[1]).toStringWithFormat("dd.MM.yyyy HH:mm");
      }
      this.dateDisplayed = this.dates[0] ? this.dates[0].toISOString() : new Date().toISOString();
      this.$nextTick(() => {
        this.dateDisplayed = undefined;
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.datesLast = this.value.slice();
        if (this.value[0] && this.value[1]) {
          this.datesString = [...[this.value[0].toStringWithFormat("yyyy-MM-dd"), this.value[1].toStringWithFormat("yyyy-MM-dd")]];
        } else {
          this.datesString = [null, null];
        }
      },
      deep: true,
    },
    time0: {
      handler() {
        this.refreshValues();
      },
    },
    time1: {
      handler() {
        this.refreshValues();
      },
    },
    datesString: {
      handler() {
        this.refreshValues();
        if (this.userSettings.showTimeOnDatePicker) {
          if (this.dates[1]) {
            this.showClock1 = true;
          } else {
            this.showClock0 = true;
          }
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.dialog.data) {
      // this.dates = [...[this.dialog.data[0], this.dialog.data[1]]];
      this.datesString = [...[this.dialog.data[0].toStringWithFormat("yyyy-MM-dd"), this.dialog.data[1].toStringWithFormat("yyyy-MM-dd")]];
      this.$nextTick(() => {
        this.showClock0 = false;
        this.showClock1 = false;
      });
    }
    if (this.dialog.options) {
      if (this.dialog.options.title != undefined) {
        this.title = this.dialog.options.title;
      }
      if (this.dialog.options.buttonOKText != undefined) {
        this.buttonOKText = this.dialog.options.buttonOKText;
      }
      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
      if (this.dialog.options.toString != undefined) {
        this.toStringFn = this.dialog.options.toStringFn;
      }
    }
  },
  mounted() {},
};
</script>
<style scoped>
</style>